import { createWidget } from '@funtech-int/rival';

import { MoviePromoBlockProps } from './components/MoviePromoBlock/MoviePromoBlock';
import { MovieCardModalContentProps } from './components/MovieCardModal/MovieCardModal';
import { PlayerSeriesStructureProps } from './components/PlayerSeriesStructure/PlayerSeriesStructure';

export const moviePromoBlockWidget = createWidget<unknown, MoviePromoBlockProps>();

export const movieCardModalWidget = createWidget<unknown, MovieCardModalContentProps>();

export const playerSeriesStructureWidget = createWidget<unknown, PlayerSeriesStructureProps>();
